<ng-template #content let-c="close" let-d="dismiss" *ngIf="edit">
  <div class="modal-header">
    <label class="modal-title" id="modal-basic-title">Crop your photo</label>
    <button type="button" class="close" (click)="onClose();d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div style="height: 300px;">
      <image-cropper
      [imageChangedEvent]="imageChangedEvent"
      [maintainAspectRatio]="true"
      [containWithinAspectRatio]="containWithinAspectRatio"
      [aspectRatio]="4 / 3"
      [resizeToWidth]="256"
      [cropperMinWidth]="128"
      [onlyScaleDown]="true"
      [roundCropper]="false"
      [canvasRotation]="canvasRotation"
      [transform]="transform"
      [alignImage]="'center'"
      [output]="'base64'"
      [style.display]="showCropper ? null : 'none'"
      format="png"
      (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded($event)"
      (loadImageFailed)="loadImageFailed($event)">
    </image-cropper>
    </div>
    <div class="preview">
      <div for="">{{'Preview' | translate}}</div>
      <img [src]="croppedImage" width="25%" [style.border]="croppedImage ? '1px solid #8f8d8dbd' : 'none'" />
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="onSetAvatar();c('Save click')">{{'Set new photo' | translate}}</button>
  </div>
</ng-template>

<div class="avatar-container">
  <img [ngClass]="{'isActive': configs.isActive}" alt="Avatar" class="avatar"  [src]="imageSrc" onerror="this.src='/assets/images/common/user-b.svg'">
  <div *ngIf="edit">
    <input type="file" class="input-file" id="image" onclick="this.value=null;" (change)="fileChangeEvent($event)" accept="image/*" />
    <div class="overlay">
      <label for="image" class="edit-img-btn" style="display: none;">
        <mat-icon>edit</mat-icon>
      </label>

    </div>
  </div>
  <div *ngIf="delete && imageSrc !== originalImageSrc" class="del-img-btn" (click)="removeAvatar()">
      <mat-icon svgIcon="icon_del"></mat-icon>
  </div>
</div>

